// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mozv","select":"styles_select__o_XYR"};